import React from 'react';
import { Select } from '../select/select';
import countryList from 'react-select-country-list';

export function CountrySelectInput({ value, onChange, ...props }) {
	const options = React.useMemo(() => countryList().getData(), []);

	const _value = React.useMemo(() => {
		if(!value) {
			return null;
		}

		return {
			value,
			label: countryList().getLabel(value)
		}
	}, [value]);

	return (
		<Select
			options={options}
			value={_value}
			onChange={({ value }) => onChange(value)}
			{...props}
		/>
	)
}
